import { render, staticRenderFns } from "./Cols-75-25.vue?vue&type=template&id=9f577a28&scoped=true&"
import script from "./Cols-75-25.vue?vue&type=script&lang=js&"
export * from "./Cols-75-25.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f577a28",
  null
  
)

export default component.exports